<template>
  <v-app>
    <app-bar
      color="bar"
      elevation="2"
      @toggleNavDrawer="toggleNavDrawer"
    />

    <navigation-drawer
      v-model="displayNavDrawer"
    />

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
      <footer-component />
      <cookie-dialog />
      <first-login-dialog />
    </v-main>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar/AppBar.vue';
import NavigationDrawer from '@/components/NavDrawer/NavigationDrawer.vue';
import FooterComponent from '@/layouts/Footer.vue';
import CookieDialog from '@/components/CookieDialog.vue';
import FirstLoginDialog from '@/components/FirstLoginDialog.vue';
import { useAuthStore } from '@/store/auth.module';
import { useUserStore } from '@/store/user.module';

export default {
  name: 'PrivateLayout',
  components: {
    AppBar,
    NavigationDrawer,
    FooterComponent,
    CookieDialog,
    FirstLoginDialog,
  },
  data() {
    return {
      displayNavDrawer: false,
    };
  },
  computed: {
    currentUser() {
      return useUserStore().currentUser;
    },
    userUpdatedAt() {
      return useAuthStore().userUpdatedAt;
    },
  },
  mounted() {
    this.refreshCurrentUser();
  },
  methods: {
    toggleNavDrawer() {
      this.displayNavDrawer = !this.displayNavDrawer;
    },
    refreshCurrentUser() {
      setInterval(() => {
        const updateDateLimit = new Date(this.userUpdatedAt);
        updateDateLimit.setHours(updateDateLimit.getHours() + 6);
        if (updateDateLimit < new Date()) {
          useAuthStore().refreshCurrentUser;
        }
      }, 5000);
    },
  },
};
</script>

<style scoped>
.v-main {
  margin-top: 90px;
  padding: 0 !important;
  overflow-y: auto;
  height: calc(100% - 90px);
}

.v-container {
  min-height: calc(100% - 56px);
}
</style>
